export const fadeInSpeed = "900"
export const fadeInStep = 100
